import { Component, OnInit,Input, OnDestroy } from '@angular/core';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { ScreeningAdditionalData, ScreeningLight, TriggerRecordTogglePayload } from 'src/app/models/screeningInvite';
import { Subscription } from 'rxjs';
import { SearchRecord, VendorResponseTypes } from 'src/app/packages-module/models/searchPackage';
import { take, tap } from 'rxjs/operators';
import { EvictionRecord } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { ToastrService } from 'ngx-toastr';
import { ScreeningService } from '../../services/screening.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SearchAddDialogComponent } from 'src/app/packages-module/components/search-add-dialog/search-add-dialog.component';
import { SearchPackageService } from 'src/app/services/search-package.service';
@Component({
  selector: 'app-eviction-records-manager',
  templateUrl: './eviction-records-manager.component.html',
  styleUrls: ['./eviction-records-manager.component.less']
})
export class EvictionRecordsManagerComponent {
  @Input() pkg : ScreeningAdditionalData;
  loading : boolean = true;
  $rcrdsLoaded : Subscription;
  modalRef : NgbModalRef;
  lastKey : any = {
    key : 'excludeFromReport',
    ascending : false
  };
  constructor(public appData: ApplicantDataService, public toast : ToastrService, public screenings : ScreeningService, 
    public modalService : NgbModal, public srchs : SearchPackageService){

  }
  ngOnDestroy(): void {
    this.$rcrdsLoaded.unsubscribe();
  }
  ngOnInit(): void {
    this.$rcrdsLoaded = this.appData.$evicRecordsLoaded.subscribe(()=>{ 
      this.appData.sortByKey(this.appData._evictionRecords,this.lastKey.key,this.lastKey.ascending);
      this.loading = false;});
    this.appData.GetEvictionRecordsForApplicant(this.pkg.searchEntryId);
  }

  toggleRecordStatus(include : boolean, record : EvictionRecord){
    let pld = new TriggerRecordTogglePayload();
    pld.recordIds = [record.evictionRecordId];
    pld.recordsIncluded = include;
    pld.searchEntryId = this.pkg.searchEntryId;
    pld.searchEntryId = this.pkg.searchEntryId;
    pld.searchType = VendorResponseTypes.Eviction;
    
    this.appData.ToggleRecord2([pld]).pipe(take(1), tap(_=>{
     console.info(_);
    })).subscribe(()=>{
      this.toast.success(`Record Toggle Success`);
      record.excludeFromReport = !include
    },
    ()=>{this.toast.error(`Record Toggle Failed`);});
  }

  sort(key : string){
    if(this.lastKey.key == key){
      this.lastKey.ascending = !this.lastKey.ascending;
    }else{
      this.lastKey.key = key;
      this.lastKey.ascending = false;
    }
    this.appData.sortByKey(this.appData._evictionRecords,this.lastKey.key,this.lastKey.ascending)
  }

  public get screeningToEdit() : ScreeningLight {
    return this.screenings.screenings[0];
  }

  orderCounty(record : EvictionRecord){
    let stateCode: string = record.state;
    let county: string;
    //get the county and state from the record address
    this.screenings.GetApplicantCountyFromAddressParts(record.addressLine,record.city,record.state).pipe(tap((res: any) => {
      county = res.county;
      if(this.screeningToEdit.additionalData.filter((sad : ScreeningAdditionalData) => {
        //we can check the search name here because of how we append it now
        let hasSrch =  sad.searchName.toLowerCase().includes(county.toLowerCase()) 
          && sad.searchName.toLowerCase().includes(stateCode.toLowerCase()) 
          && sad.searchName.toLowerCase().includes("eviction"); 
        return hasSrch;
  
      }).length > 0) {
        //validation errors
        this.toast.error(`County search for this jurisdiction already exists. Please review and add search manually`,'', { disableTimeOut : true, closeButton : true });
        return;
      }
      
      this.modalRef = this.modalService.open(SearchAddDialogComponent, { centered: true, size: 'lg' })
      this.modalRef.componentInstance.name = 'SearchAddDialogComponent';
      let searchToAdd = new SearchRecord();
      searchToAdd.searchType = VendorResponseTypes.EvictionVerification;
      searchToAdd.searchMeta = {
        state : stateCode,
        county : county
      }
      searchToAdd.name = 'Eviction Verification';
      this.modalRef.componentInstance.searchAdded.subscribe((scc: SearchRecord) => this.searchAdded2(scc));

      this.modalRef.componentInstance.search = searchToAdd;
      this.modalRef.componentInstance.packageEditMode = false;
      this.modalRef.componentInstance.additionalData = this.pkg;
      this.modalRef.componentInstance.isCustomSearch = false;
      this.modalRef.componentInstance.iscountyAutoMode = true;
      console.warn(searchToAdd);
      
    },
    err => {
      this.toast.error(`Error getting county from address. Please add search manually`,'', { disableTimeOut : true, closeButton : true });
    },
    () => {
      
    })).subscribe()
    //then verify we don't already have one in the additional data before proceeding

  }

  searchAdded2(event : SearchRecord){
    console.info(event);
    this.srchs.addSearchToReport(this.screeningToEdit.id, event.id).subscribe(result => {
      this.toast.success('search added to report');
      this.toast.warning()

      this.screenings.FetchScreeningAdditionalData(this.screeningToEdit.id).subscribe((rep:ScreeningAdditionalData[])=>{
        this.screeningToEdit.additionalData = [];
        rep.forEach(element => {
          this.screeningToEdit.additionalData.push(Object.assign(new ScreeningAdditionalData(),element))
        });
      },(err:any)=>{
        this.toast.warning('There was an error reloading your search results list.Please refresh the page to get your new search.','Error Refreshing Searches')
      })     
    },
    (error) => {
      //the search failed to save...
      this.toast.error('Search failed to add to report!', '', { closeButton: true, disableTimeOut: true });
    });  
  }
}
